import { useMountEffect } from "@react-hookz/web";
import qs from "qs";
import type { FunctionComponent } from "react";
import { useMemo } from "react";

import { FloatClickableArea } from "~/components/story-style/story-style-float-clickable-area";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";

import bottomRightBackgroundImage from "./bottom-right-background.png";
import {
  BackgroundContainer,
  ButtonContainer,
  Container,
  ContentContainer,
  GradientOverlay,
  Link,
  StyledEmailLogo,
  StyledImage,
  StyledSignUpButton,
  StyledSubTitle,
  StyledTitle,
} from "./styles";

type OriginPayload = {
  origin?: string;
};

type Props = {
  handleGoToNextPage: () => void;
  handleGoToPreviousPage: () => void;
};

export const StoryStyleNewsletterSignUpCard: FunctionComponent<Props> = ({
  handleGoToNextPage,
  handleGoToPreviousPage,
}) => {
  useMountEffect(() => {
    sendGATracking({
      action: `Story Card/Style/Impression`,
      category: "Story Card",
      label: "newsletter sign up",
      /**
       * The value is hard-coded
       * so the stakeholders can know it would be a newsletter sign-up card during data analysis
       */
      value: 29,
    });

    sendGA4Tracking({
      action: "imp",
      category: "storycard",
      customized_parameters: {
        card_num: 29,
        section_name: "Style",
      },
      subcategory: "",
    });
  });

  const parsedQueryString = useMemo<OriginPayload>(
    () =>
      qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      }),
    [],
  );

  const handleNewsletterClick = () => {
    sendGATracking({
      action: `Story Card/newsletter/Style/Click`,
      category: "Story Card",
      label: parsedQueryString.origin ?? "",
    });

    sendGA4Tracking({
      action: "click",
      category: "storycard",
      customized_parameters: {
        cta_type: "nl_signup",
      },
      subcategory: "",
    });
  };

  const renderNewsLetterLink = () => (
    <Link
      href="/newsletter/style-invite?pgtype=story&module=newsletter"
      rel="noreferrer"
      target="_blank"
      onClick={handleNewsletterClick}
    >
      <StyledSignUpButton>Sign Up Now</StyledSignUpButton>
    </Link>
  );

  return (
    <Container>
      <FloatClickableArea
        handleGoToNextPage={handleGoToNextPage}
        handleGoToPreviousPage={handleGoToPreviousPage}
      />
      <ContentContainer>
        <StyledEmailLogo />
        <StyledSubTitle>
          st<i>a</i>y on tr<i>e</i>nd/
        </StyledSubTitle>
        <StyledTitle>Get the</StyledTitle>
        <StyledTitle>
          STYLE <i>invite</i>
        </StyledTitle>
        <StyledTitle>newsletter/</StyledTitle>
      </ContentContainer>
      <ButtonContainer>{renderNewsLetterLink()}</ButtonContainer>
      <BackgroundContainer>
        <GradientOverlay />
        <StyledImage alt={bottomRightBackgroundImage.alt} src={bottomRightBackgroundImage.src} />
      </BackgroundContainer>
    </Container>
  );
};

StoryStyleNewsletterSignUpCard.displayName = "StoryStyleNewsletterSignUpCard";
